import { TemplateItemType } from '../../header/components/create-menu/data/constants';
import { getCookie } from './cookies.service';

export const prepareTemplatesForMaxDiff = (data: any) => {
    if (!data?.createMenu?.templates) {
        return data;
    }

    const parsedData = { ...data };

    if (parsedData.user?.userDetailsTraits?.isMaxDiffEnabled) {
        // @ts-ignore
        parsedData.createMenu.templates = parsedData.createMenu.templates.reduce((acc, item) => {
            if (TemplateItemType.MAXDIFF.includes(item.id)) {
                // Patch action items data to add "New" label to MaxDiff
                // @see https://toluna.atlassian.net/browse/TIP-3263
                acc.push({ ...item, badge: true });
            } else {
                acc.push(item);
            }

            return acc;
        }, []);
    } else {
        // Patch templates data to remove MaxDiff
        parsedData.createMenu.templates = parsedData.createMenu.templates.filter(
            // @ts-ignore
            template => !TemplateItemType.MAXDIFF.includes(template.id)
        );
    }

    return parsedData;
};

export const createWsUrl = (baseUrl: any, params: any) => {
    const url = new URL(baseUrl);
    params.forEach((param: any) => {
        // @ts-ignore
        url.searchParams.append(param, getCookie(param));
    });
    return url.href;
};

export const getIsImpersonated = () => {
    const impersonateCookie = getCookie('IsImpersonate');
    const isImpersonate = impersonateCookie && impersonateCookie.toLowerCase() === 'true';
    return isImpersonate;
};

export const getIsImpersonationWsValid = (wsObject: any) =>
    wsObject?.socketUrl && wsObject?.redirectUrl && wsObject?.customerId && getIsImpersonated();

export const validateAuthHeader = () => {
    let authToken = '';

    if (getIsImpersonated()) {
        authToken = getCookie('AuthToken') ?? '';
    } else {
        const storedAuthToken = localStorage.getItem('Authorization');
        const headerAuthToken = window.tcp?.networkService?.getAuthorizationHeader?.()?.replace('TEF ', '');

        if (storedAuthToken && storedAuthToken !== headerAuthToken) {
            authToken = storedAuthToken;
        }
    }
    if (authToken?.length) {
        window.tcp?.networkService?.addAuthorizationHeader?.(authToken);
    }
};
